export default function Footer() {
  return (
    <footer className="bg-feenex-blue text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/1c25e8811aca7c6ca186f30e4b2227d5/8afac7b945d8ebdb82ad7b0d561e6124.png" 
              alt="Feenex" 
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-feenex-white/70 text-sm leading-relaxed max-w-md mb-4">
              Soluções estruturadas em direitos creditórios e ativo moeda para empresas que buscam eficiência tributária com total conformidade legal.
            </p>
            <a 
              href="/politica-de-privacidade" 
              className="inline-flex items-center gap-2 text-feenex-gold hover:text-feenex-white text-sm font-semibold transition-colors cursor-pointer"
            >
              <i className="ri-shield-check-line"></i>
              Política de Privacidade e Proteção de Dados
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-feenex-gold font-semibold mb-4 text-sm uppercase tracking-wider">
              Navegação
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="#solucoes" className="text-feenex-white/70 hover:text-feenex-gold text-sm transition-colors cursor-pointer">
                  Soluções
                </a>
              </li>
              <li>
                <a href="#como-funciona" className="text-feenex-white/70 hover:text-feenex-gold text-sm transition-colors cursor-pointer">
                  Como Funciona
                </a>
              </li>
              <li>
                <a href="#diferenciais" className="text-feenex-white/70 hover:text-feenex-gold text-sm transition-colors cursor-pointer">
                  Diferenciais
                </a>
              </li>
              <li>
                <a href="#faq" className="text-feenex-white/70 hover:text-feenex-gold text-sm transition-colors cursor-pointer">
                  Perguntas Frequentes
                </a>
              </li>
              <li>
                <a href="#contato" className="text-feenex-white/70 hover:text-feenex-gold text-sm transition-colors cursor-pointer">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-feenex-gold font-semibold mb-4 text-sm uppercase tracking-wider">
              Contato
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-feenex-gold mt-0.5"></i>
                <span className="text-feenex-white/70">+55 (11) 94770-5303</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-feenex-gold mt-0.5"></i>
                <span className="text-feenex-white/70">comercial@feenex.com.br</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-feenex-gold mt-0.5"></i>
                <span className="text-feenex-white/70">São Paulo, SP</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-feenex-white/50 text-sm">
              © 2025 Feenex. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-feenex-white/50 hover:text-feenex-gold text-sm transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}